export function getHeight (height = 0) {
  return (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - height
}



// WEBPACK FOOTER //
// ./src/util/getHeight.js